import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  ICardAccess,
  ICardCredentials,
  IuserGroup,
  IUserProfile,
} from 'src/app/user-management/user-management-interfaces';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormGroupDirective,
} from '@angular/forms';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { NotificationService } from 'src/app/shared/errors/notification.service';
import { AccountSettingsService } from 'src/app/shared-layout/header/account-settings/account-setting.service';

@Component({
  selector: 'app-user-profile-physical-credentials',
  templateUrl: './user-profile-physical-credentials.component.html',
  styleUrls: ['./user-profile-physical-credentials.component.scss'],
})
export class UserProfilePhysicalCredentialsComponent implements OnInit {
  @Input() dialogRef?: any; //close event of parent component
  @Input() profileDetails?: any;
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();
  @Input() userDetailsFormGroupName!: string;
  step: number = 1;
  @Input() userCredentials: ICardCredentials[] = [];
  selectedCredentials!: ICardCredentials;
  /**
   * @description control getter formgroup
   * @returns rective controls
   */
  get formInstance() {
    return this.formGroup.controls;
  }

  readonly LANG_CONST = LANG_CONST;
  formGroup!: FormGroup;

  constructor(
    private rootFormGroup: FormGroupDirective,
    private accountSettingService: AccountSettingsService,
    private notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    this.formGroup = this.rootFormGroup.control.get(
      this.userDetailsFormGroupName
    ) as FormGroup;
  }

  /**
   * @description getUserAccessOnRFID function will call the getUserAccessOnRFID API
   * @returns void
   */
  getUserAccessOnRFID(cardId: string, badgeId: string): void {
    this.accountSettingService.getUserAccessOnRFID(cardId, badgeId).subscribe({
      next: (res: any) => {
        if (res) {
          const cardAccess = res.getUserAccessOnRFID?.cardAccess;
          this.selectedCredentials.accessCount =
            cardAccess?.temporaryAccess.length +
            cardAccess?.homeAccess.length +
            cardAccess?.otherAccess.length;
        }
      },
    });
  }

  viewCredentialDetails(
    cardId: string,
    cardName: string,
    badgeId: string,
    cardStatus: string,
    disable: boolean,
    cardAccess: ICardAccess
  ): void {
    this.selectedCredentials = {
      cardId,
      cardName,
      badgeId,
      cardStatus,
      disable,
      cardAccess,
    };
    this.step = 2;
    this.getUserAccessOnRFID(cardId, badgeId);
  }

  /**
   * @description close modal dialogue with help of material service
   * @returns void
   */
  closeDialog(): void {
    this.dialogRef?.close();
  }

  /**
   * @description navigate to back screen
   * @returns void
   */
  navigateBack(): void {
    if (this.step <= 1) {
      this.stepperChange.emit((this.stepper = 1));
      return;
    } else {
      this.step = this.step - 1;
    }
  }

  /**
   * @description setSelectedCredentials sets the selected credentials
   * @returns void
   */
  setSelectedCredentials(selected: ICardCredentials) {
     this.selectedCredentials = selected;
  }
}
